import React from "react";
import { useForm } from "react-hook-form";

function PayChallanModal({ title, onClose, payChallan, data }) {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    reset,
  } = useForm({
    defaultValues: {
      bankName: "Bank Al Falah",
      accountNo: "",
    },
  });

  if (!data) {
    return null;
  }

  const saveData = (formData) => {
    const formWithAdditionalData = {
      ...formData,
      id: data.admissionVoucherId,
      voucherNo: data.voucherNo,
      // registrationNo: data.registrationNo,
    };
    // console.log("modal", formWithAdditionalData);

    payChallan(formWithAdditionalData);
  };

  return (
    <>
      <div
        className="modal fade show"
        tabIndex="-1"
        style={{ display: "block" }}
      >
        <div className="modal-dialog modal-md">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="mb-0">{title}</h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
              ></button>
            </div>
            <div className="modal-body">
              <div className="mb-3">
                <div className="row fs-9">
                  <div className="col-md-6">
                    <div>
                      <label className="fw-bold">Student Name:</label>
                      <span className="ms-1">{data.studentName}</span>
                    </div>
                    <div>
                      <label className="fw-bold">Registration No:</label>
                      <span className="ms-1">{data.registrationNo}</span>
                    </div>
                    <div>
                      <label className="fw-bold">Challan No:</label>
                      <span className="ms-1">{data.voucherNo}</span>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div>
                      <label className="fw-bold">Center:</label>
                      <span className="ms-1">{data.centerName}</span>
                    </div>
                    <div>
                      <label className="fw-bold">Class:</label>
                      <span className="ms-1">{data.className}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mb-3 table-responsive">
                <table className="table table-bordered custom-table m-0">
                  <thead>
                    <tr>
                      <th className="fw-bold">Fee Type</th>
                      <th className="fw-bold">Fee Amount</th>
                      <th className="fw-bold">Concession (%)</th>
                      <th className="fw-bold">Net Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.admissionVoucherDetailDto.length > 0 ? (
                      <>
                        {data.admissionVoucherDetailDto.map((fee, index) => (
                          <tr key={index}>
                            <td>{fee.feeTypeName}</td>
                            <td>{fee.amount}</td>
                            <td>{fee.concessionPercentage}</td>
                            <td>{fee.netAmount}</td>
                          </tr>
                        ))}
                        <tr>
                          <td colSpan="3">
                            <strong>Total Amount</strong>
                          </td>
                          <td>
                            <strong>
                              {data.admissionVoucherDetailDto.reduce(
                                (total, fee) => total + fee.netAmount,
                                0,
                              )}
                            </strong>
                          </td>
                        </tr>
                      </>
                    ) : null}
                  </tbody>
                </table>
              </div>

              <form onSubmit={handleSubmit(saveData)}>
                <div className="mb-5">
                  <div className="row fs-9 g-3">
                    <div className="col-md-3">
                      <label className="fw-bold">
                        Bank Name <span className="text-danger fs-9">*</span>
                      </label>
                      <select
                        {...register("bankName", {
                          required: "This field is required.",
                        })}
                        className="form-select"
                      >
                        <option value="">Select</option>
                        <option value="Bank Al Falah">Bank Al Falah</option>
                        <option value="Meezan Bank">Meezan Bank</option>
                        <option value="Habib Bank">Habib Bank</option>
                      </select>
                      {errors.bankName && (
                        <small className="text-danger">
                          {errors.bankName.message}
                        </small>
                      )}
                    </div>
                    <div className="col-md-3">
                      <label className="fw-bold">
                        Account Number{" "}
                        <span className="text-danger fs-9">*</span>
                      </label>
                      <input
                        {...register("accountNo", {
                          required: "This field is required.",
                        })}
                        type="text"
                        className="form-control"
                      />
                      {errors.accountNo && (
                        <small className="text-danger">
                          {errors.accountNo.message}
                        </small>
                      )}
                    </div>
                    <div className="col-md-3">
                      <label className="fw-bold">
                        Receipt Number{" "}
                        <span className="text-danger fs-9">*</span>
                      </label>
                      <input
                        {...register("receiptNo", {
                          required: "This field is required.",
                        })}
                        type="text"
                        className="form-control"
                      />
                      {errors.receiptNo && (
                        <small className="text-danger">
                          {errors.receiptNo.message}
                        </small>
                      )}
                    </div>
                    <div className="col-md-3">
                      <label className="fw-bold">Remarks</label>
                      <input
                        {...register(
                          "remarks",
                          //   {
                          //   required: "This field is required.",
                          // }
                        )}
                        type="text"
                        className="form-control"
                      />
                      {errors.remarks && (
                        <small className="text-danger">
                          {errors.remarks.message}
                        </small>
                      )}
                    </div>
                  </div>
                </div>

                <div className="d-flex gap-2 justify-content-end">
                  <button
                    type="submit"
                    className="btn btn-sm btn-primary"
                    onClick={payChallan}
                  >
                    Confirm Paid
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary"
                    onClick={onClose}
                  >
                    Close
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
}

export default PayChallanModal;
